function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 6.1c-.13.4-.36.73-.57 1.08a12 12 0 01-2.52 2.93 7.42 7.42 0 01-2.74 1.49 6.15 6.15 0 01-4.48-.44 8.63 8.63 0 01-2.33-1.71c-.9-.9-1.65-1.93-2.24-3.07C.57 6.3.54 6.2.5 6.1v-.18c.13-.4.36-.74.57-1.09.7-1.1 1.51-2.1 2.51-2.93A7.43 7.43 0 016.33.4a6.15 6.15 0 014.48.44 8.64 8.64 0 012.33 1.71c.9.9 1.65 1.93 2.24 3.06l.12.3v.18zm-7.43 4.44c.38 0 .75-.06 1.1-.15a6.12 6.12 0 002.39-1.23 11.07 11.07 0 002.57-3.1c.03-.05.02-.09 0-.13a11.85 11.85 0 00-1.68-2.27 7.49 7.49 0 00-2.38-1.74 4.9 4.9 0 00-3.6-.21c-.85.27-1.6.74-2.27 1.33-.94.82-1.7 1.8-2.33 2.9-.03.04-.03.08 0 .12.33.58.71 1.13 1.13 1.65a8.93 8.93 0 002.14 1.95c.88.55 1.82.87 2.93.88z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 8.6A2.55 2.55 0 015.5 6c0-1.43 1.12-2.6 2.5-2.6s2.5 1.17 2.5 2.6c0 1.43-1.12 2.6-2.5 2.6zM6.75 6a1.26 1.26 0 00.77 1.2 1.2 1.2 0 001.36-.28 1.31 1.31 0 00.28-1.41c-.1-.24-.26-.44-.46-.59a1.22 1.22 0 00-1.58.16 1.3 1.3 0 00-.37.91z"
});

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "#fff",
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6c23dd63.svg";
export { ForwardRef as ReactComponent };